// @ts-nocheck
import { makeStyles } from '@material-ui/core';

const SIDEBAR_WIDTH = 287;

export const trackerStyles = {
  root: {
    margin: '1em',
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'relative',
    flex: 1,
    alignItems: 'stretch',
    flexWrap: 'nowrap',
    minHeight: 0,
  },
  drawerContainer: {
    position: 'relative',
    display: 'flex',
    flex: 1,
  },
  drawerPaper: {
    overflowY: 'auto',
    overflowX: 'hidden',
    background: 'var(--color-sidebar-bg)',
    top: 64,
    bottom: 0,
    width: `${SIDEBAR_WIDTH}px`,
    maxWidth: `${SIDEBAR_WIDTH}px`,
    height: 'unset',
    '&::-webkit-scrollbar': { width: 5 },
    '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: 100 },
  },
  sidebarSectionHeader: {
    padding: '20px 20px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    backgroundColor: 'var(--color-sidebar-bg)',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  sidebarSectionTitle: {
    fontWeight: 400,
    fontSize: '1.05rem',
    color: '#fff',
    letterSpacing: '0.02em',
  },
  addButton: {
    height: 32,
    padding: '0 14px',
    border: 'none',
    borderRadius: 8,
    backgroundColor: 'var(--color-primary)',
    color: '#fff',
    fontSize: '0.8rem',
    fontWeight: 400,
    textTransform: 'none',
    transition: 'all 0.2s',
    '&:hover': { backgroundColor: '#ff8657' },
    '& .MuiButton-startIcon': { marginRight: 6 },
  },
  sidebarSection: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 0,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': { width: '6px' },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { background: 'rgba(255,255,255,0.2)', borderRadius: '3px' },
  },
  sidebarItem: {
    borderBottom: '1px solid rgba(255,255,255,0.1)',
    padding: '14px 20px',
    margin: 0,
    borderRadius: 0,
    transition: 'background-color 0.15s ease',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.12)',
      '& $sidebarActionBtn': { opacity: 1 },
    },
  },
  sidebarActionBtn: {
    opacity: 0,
    transition: 'opacity 0.15s ease',
    padding: 3,
    color: 'rgba(255,255,255,0.4)',
    '&:hover': { color: 'rgba(255,255,255,0.8) !important' },
  },
  sidebarActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    flexShrink: 0,
    marginLeft: 4,
  },
  sidebarItemActive: {
    backgroundColor: 'rgba(223, 109, 46, 0.15) !important',
    borderLeft: '3px solid var(--color-primary) !important',
    '&:hover': {
      backgroundColor: 'rgba(223, 109, 46, 0.2) !important',
    },
  },
  sidebarItemTitle: {
    fontWeight: 400,
    fontSize: '0.875rem',
    color: '#fff',
    lineHeight: 1.4,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    paddingRight: 8,
  },
  sidebarItemDate: {
    fontSize: '0.7rem',
    color: 'rgba(255,255,255,0.35)',
    marginTop: 4,
  },
  sidebarNoItems: {
    padding: '24px 20px',
    textAlign: 'center',
    color: 'rgba(255,255,255,0.4)',
    fontSize: '0.85rem',
  },
  toggleButton: {
    position: 'fixed',
    left: `${SIDEBAR_WIDTH - 17}px`,
    top: '75px',
    zIndex: 1200,
    color: '#fff',
    background: 'var(--color-primary)',
    '&:hover': { color: '#fff', background: 'var(--color-primary)' },
  },
  toggleButtonCollapsed: {
    position: 'fixed',
    left: '1px',
    top: '75px',
    zIndex: 1200,
    color: '#fff',
    background: 'var(--color-primary)',
    '&:hover': { color: '#fff', background: 'var(--color-primary)' },
  },
  mainContentArea: {
    flex: 1,
    transition: 'margin-left 0.3s ease',
    padding: '15px 16px',
    minWidth: 0,
  },
  paper: {
    minHeight: '40em',
    height: '100%',
  },
  text: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  itemWrapper: {
    margin: '0em',
    width: '100%',
  },
  ml1: {
    marginLeft: '1em',
  },
  mr1: {
    marginRight: '1em',
  },
  mr05: {
    marginRight: '.5em',
  },
  mb1: {
    marginBottom: '1em',
  },
  itemsPaper: {
    marginTop: '1em',
    padding: '1em',
  },
  buttonPaper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 1em 1em 0',
  },
  button: {
    marginTop: '1em',
    marginLeft: '1em',
  },
  modified: {
    borderLeft: '0.5em solid var(--color-primary)',
    marginLeft: '-1em',
    paddingLeft: '0.5em',
  },
  paperTrackerViewerDetails: {
    marginLeft: '1em',
    marginRight: '0em',
    height: '100%',
    padding: '0 1em 1em 1em',
  },
  chartWrapper: {
    marginTop: '1em',
    padding: '1em',
  },
  trackerHeader: {
    display: 'flex',
    alignItems: 'center',

    minHeight: 56,
    paddingTop: 10,
  },
  preventiveActions: {
    height: 550,
    marginTop: '1em',
  },
  redText: {
    color: 'var(--color-primary)',
  },
  alignCenter: {
    height: '18vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  periodSelector: {
    marginRight: 10,
    background: 'white',
    borderRadius: '5px',
  },
  periodSelectorInput: {
    '& .MuiOutlinedInput-input': {
      padding: '10px !important',
      width: 100,
    },
  },

  iconCircleButton: {
    background: 'var(--color-primary)',
    width: '35px',
    height: '35px',
    '&:hover': {
      background: '#ff8657',
    },
  },
  iconStyle: {
    color: 'white',
  },
  trackerHeaderTitle: {
    paddingLeft: '360px',
    top: '60px',
    position: 'absolute',
  },
  gridButtonLayout: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 10,
  },
};

export const useTrackerStyles = makeStyles(trackerStyles);
